// React
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
// MUI
import { Grid, Box, Button } from "@mui/material";
import Iconify from "../../../components/iconify/Iconify";
// Constants
import EntityConstants from "../../../configs/EntityConstants";
import MessageContants from "../../../configs/MessageContants";
// Service
import { get, post, put } from "../../../services/FetchHelper";
import SpinService from "../../../services/SpinService";
// Utils
import {
    InitialFinanceTransactionCodeSetupState,
    FinanceTransactionCodeSetupSchema,
    FinanceTransactionCodeSetupFormFields,
} from "./Configuration.utils";
// Styles
import { StyledDrawerForm } from "../../../configs/GoStyles";
//Third party
import { Form, Formik } from "formik";
import toast from "react-hot-toast";
import GoForm from "../../../components/Inputs/GoForm";
import PermissionConstants from "../../../configs/PermissionConstants";
import usePermissions from "../../../hooks/usePermissions";
const FinanceTransactionCodeSetup = ({ id, onClose }) => {
    const permissions = usePermissions();
    const spinService = SpinService();
    const [finance_transaction_code_setup, setFinanceTransactionCodeSetup] = useState(InitialFinanceTransactionCodeSetupState);

    const getFinanceTransactionCodeSetup = async (id) => {
        spinService.on();
        const response = await get(EntityConstants.FINANCE_TRANSACTION_CODE_SETUPS + `/${id}`);
        const data = await response.json();
        setFinanceTransactionCodeSetup(data);
        spinService.off();
    };

    const handleSubmit = async (values) => {
        spinService.on();
        const isNewFinanceTransactionCodeSetup = values.id === undefined;
        const url = isNewFinanceTransactionCodeSetup ? EntityConstants.FINANCE_TRANSACTION_CODE_SETUPS : EntityConstants.FINANCE_TRANSACTION_CODE_SETUPS + `/${values.id}`;
        const method = isNewFinanceTransactionCodeSetup ? post : put;
        const response = await method(url, { finance_transaction_code_setup: values });
        if ([200, 201].indexOf(response.status) > -1) {
            toast.success(isNewFinanceTransactionCodeSetup ? MessageContants.FINANCE_TRANSACTION_CODE_SETUP_CREATED : MessageContants.FINANCE_TRANSACTION_CODE_SETUP_UPDATED);
            onClose();
        }
        spinService.off();
    };

    useEffect(() => {
        if (id !== undefined) {
            getFinanceTransactionCodeSetup(Number(id));
        }
    }, [id]);

    return (
        <Formik
            enableReinitialize
            initialValues={finance_transaction_code_setup}
            validationSchema={FinanceTransactionCodeSetupSchema}
            onSubmit={(values) => handleSubmit(values)}
        >
            {({
                values,
                touched,
                errors,
                dirty,
                isSubmitting,
                handleChange,
                handleBlur,
                handleSubmit,
            }) => (
                <Form noValidate onSubmit={handleSubmit}>
                    <StyledDrawerForm>
                        <Grid
                            container
                            maxWidth="sm"
                            rowSpacing={1}
                            columnSpacing={{ xs: 1, sm: 2, md: 2 }}
                        >
                            {FinanceTransactionCodeSetupFormFields.map((formField, index) => {
                                return (
                                    <Grid key={index} item xs={12} sm={12} md={6} lg={6}>
                                        <GoForm
                                            config={formField}
                                            values={values}
                                            touched={touched}
                                            errors={errors}
                                            handleChange={handleChange}
                                        />
                                    </Grid>
                                );
                            })}
                        </Grid>
                        <Box sx={{ p: 2, textAlign: "right" }}>
                            <Button
                                variant="contained"
                                color="error"
                                startIcon={<Iconify icon="eva:close-circle-outline" />}
                                onClick={() => onClose()}
                            >
                                Close
                            </Button>
                            &nbsp;&nbsp;
                            {((values.id === undefined && permissions.has(PermissionConstants.FINANCE_TRANSACTION_CODE_SETUP_CREATE)) || (values.id !== undefined && permissions.has(PermissionConstants.FINANCE_TRANSACTION_CODE_SETUP_UPDATE))) &&
                                <Button
                                    variant="contained"
                                    startIcon={<Iconify icon="eva:save-fill" />}
                                    type="submit"
                                >
                                    {values.id === undefined ? 'Save' : 'Update'}
                                </Button>
                            }
                        </Box>
                    </StyledDrawerForm>
                </Form>
            )}
        </Formik>
    );
};

FinanceTransactionCodeSetup.propTypes = {
    id: PropTypes.number,
    onClose: PropTypes.any,
};

export default FinanceTransactionCodeSetup;
